<!-- 选择学员 -->
<template>
  <el-form-item :label="label">
    <yx-student-selector
      v-bind="config"
      @select="select"
      ref="child"
      @clear="clear"
      width="222px"
      :appendFlag="appendFlag">
      <template #append v-if="appendFlag">
        <slot name="append"><div style="cursor: pointer;" @click="chooseStudent">选择</div></slot>
      </template>
    </yx-student-selector>
  </el-form-item>
</template>

<script>
import { inject, onMounted, ref } from 'vue';

export default {
  kind: 'yq-学员选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ([]),
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '学员：',
    },
    appendFlag: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    campusnode: {
      type: Object,
      default() {
        return {};
      },
    },
    campusIds: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');

    function reset() {
      // eslint-disable-next-line no-use-before-define
      student.value = props.value;
      if (props.value.length > 0) {
        child.value.setField(props.value[0].name);
      } else {
        child.value.clearField();
      }
    }

    function clear() {
      // eslint-disable-next-line no-use-before-define
      student.value = [];
      child.value.clearField();
    }
    const student = useQuery('student', props.value, reset);

    if (props.value.length > 0) {
      onMounted(() => {
        child.value.setField(props.value[0].name);
      });
    }

    function select(obj) {
      student.value = [obj];
    }

    // 弹窗选择学员
    const popup = inject('popup');
    async function chooseStudent(type) {
      const node = props.campusnode;
      let campus = props.campusIds;
      if (node && node.child) {
        campus = node.child.campus;
      }
      if (type === 'clear') {
        student.value = [];
      } else {
        const res = await popup('student-chooser', {
          multiple: props.multiple,
          lists: student.value,
          campusIds: campus,
        });
        student.value = res;
        child.value.setField(res.map((i) => i.name).join());
      }
    }

    return {
      select,
      child,
      reset,
      clear,
      chooseStudent,
    };
  },
};
</script>
